import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ToastrModule } from 'ngx-toastr';

import { IntroBannerComponent } from './components/intro-banner/intro-banner.component';
import { DIRECTIVES } from './directives';
import { COMPONENTS } from './components';

@NgModule({
	declarations: [
		DIRECTIVES,
		COMPONENTS,
	],
	imports: [
		CommonModule,
		FormsModule,
		RouterModule,
		HttpClientModule,

		FontAwesomeModule,
		CurrencyMaskModule,
		NgxMaskDirective,
		NgxMaskPipe,
		ToastrModule.forRoot({ closeButton: true, positionClass: 'top-center' }),

		ModalModule.forRoot(),

		IntroBannerComponent,
	],
	exports: [
		CommonModule,
		FormsModule,
		RouterModule,
		HttpClientModule,

		FontAwesomeModule,
		CurrencyMaskModule,
		NgxMaskDirective,
		NgxMaskPipe,
		ToastrModule,

		ModalModule,

		DIRECTIVES,
		COMPONENTS,
		IntroBannerComponent,
	],
	providers: [
		provideNgxMask()
	]
})
export class SharedModule {
}
